import React from 'react';
import { Navigate } from 'react-router-dom';
import { ROLES } from '@constants/roles.ts';
import { useUserRoles } from '@hooks/useUserRoles.ts';
import { ROUTES } from '@router/constants.ts';
import { addCallbackUrl } from '@utils/navigation.ts';

interface Props {
    children: React.ReactNode;
}

export const BlueByteAdminRoleGuard: React.FC<Props> = ({ children }) => {
    const roles = useUserRoles();
    const isBBAdmin = roles.includes(ROLES.BLUEBYTE_ADMIN);

    if (!isBBAdmin) {
        return <Navigate to={addCallbackUrl(`/${ROUTES.DEFAULT.UNAUTHORIZED}`, window)} replace />;
    }

    return children;
};
